module.exports = __webpack_public_path__ + "img/title-2.09b43149.png";